module.exports = __webpack_public_path__ + "static/img/activity-page-head.ab3e9c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fission/activity-page-head.png
// module id = xZ8g
// module chunks = 213